/* Auto open sub-menus*/
document.addEventListener("DOMContentLoaded", function () {
  // Select all top-level menu summaries inside the header
  const parentSummaries = document.querySelectorAll(
    ".header__menu-item[aria-controls^='HeaderMenu-MenuList']"
  );

  parentSummaries.forEach((summary) => {
    summary.addEventListener("click", function () {
      const parent = summary.closest("details");

      // Wait until native toggle happens
      setTimeout(() => {
        if (parent.hasAttribute("open")) {
          // Expand all child submenus
          parent.querySelectorAll("ul.header__submenu > li > details").forEach((child) => {
            child.setAttribute("open", "");
            const childSummary = child.querySelector("summary");
            if (childSummary) childSummary.setAttribute("aria-expanded", "true");
          });
          summary.setAttribute("aria-expanded", "true");
          const element = document.querySelector('.overlay');
          element.classList.add('active');
        } else {
          // Collapse all child submenus
          parent.querySelectorAll("ul.header__submenu > li > details").forEach((child) => {
            child.removeAttribute("open");
            const childSummary = child.querySelector("summary");
            if (childSummary) childSummary.setAttribute("aria-expanded", "false");
          });
          summary.setAttribute("aria-expanded", "false");
        }
      }, 0);
    });
  });

  /*Close the overlay when the overlay is click*/
    const overlay = document.querySelector('.overlay');
    const details = document.querySelector('details');
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
    });

    

});
document.querySelectorAll("details").forEach((details) => {
  details.addEventListener("toggle", () => {
    if (!details.open) {
      document.querySelector(".overlay")?.classList.remove("active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(
    ".shopify-section.shopify-section-group-header-group.section-header.shopify-section-header-sticky"
  );
  const logoImg = document.querySelector(".header__heading-logo-wrapper img");

  if (!header || !logoImg) return;

  // Store original attributes
  const original = {
    src: logoImg.getAttribute("src"),
    srcset: logoImg.getAttribute("srcset"),
    sizes: logoImg.getAttribute("sizes"),
    width: logoImg.getAttribute("width"),
    height: logoImg.getAttribute("height")
  };

  // Define your scrolled logo (adjust paths & dimensions)
  const scrolled = {
    src: "https://cdn.shopify.com/s/files/1/0923/5611/6784/files/Wayfinder_Logo_1.png?width=600",
    srcset: "https://cdn.shopify.com/s/files/1/0923/5611/6784/files/Wayfinder_Logo_1.png?width=150 150w, https://cdn.shopify.com/s/files/1/0923/5611/6784/files/Wayfinder_Logo_1.png?width=225 225w, https://cdn.shopify.com/s/files/1/0923/5611/6784/files/Wayfinder_Logo_1.png?width=300 300w",
    sizes: "(min-width: 750px) 150px, 50vw",
    width: "150",
    height: "38"
  };

  function updateLogo() {
    if (header.classList.contains("scrolled-past-header")) {
      logoImg.setAttribute("src", scrolled.src);
      logoImg.setAttribute("srcset", scrolled.srcset);
      logoImg.setAttribute("sizes", scrolled.sizes);
      logoImg.setAttribute("width", scrolled.width);
      logoImg.setAttribute("height", scrolled.height);
    } else {
      logoImg.setAttribute("src", original.src);
      logoImg.setAttribute("srcset", original.srcset);
      logoImg.setAttribute("sizes", original.sizes);
      logoImg.setAttribute("width", original.width);
      logoImg.setAttribute("height", original.height);
    }
  }

  // Run once on load
  updateLogo();

  // Watch header for class changes
  const observer = new MutationObserver(updateLogo);
  observer.observe(header, { attributes: true, attributeFilter: ["class"] });

  
/* Apply on reservation, collection, or product pages */
if (
  window.location.pathname === '/pages/reservations' ||
  window.location.pathname.includes('/collections') ||
  window.location.pathname.includes('/products') ||
  window.location.pathname.includes('/search') ||
   window.location.pathname.includes('/newsletter')
) {
  const defaultHeader = document.querySelector('.shopify-section-header-sticky');

  if (defaultHeader) {
    // Add the class immediately
    defaultHeader.classList.add('scrolled-past-header');

    // Apply border style
    defaultHeader.style.borderBottom = '1px solid #E5DED9';

    // Keep it enforced in case Shopify scripts modify classes on scroll
    const observer = new MutationObserver(() => {
      if (!defaultHeader.classList.contains('scrolled-past-header')) {
        defaultHeader.classList.add('scrolled-past-header');
      }
    });

    observer.observe(defaultHeader, { attributes: true, attributeFilter: ['class'] });
  }
}
});


/*Close any open menus*/
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".close-trigger").forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      // Find the closest parent <details> for THIS close button
      const parentMenu = trigger.closest("details");
      if (parentMenu) {
        parentMenu.removeAttribute("open");
         const element = document.querySelector('.overlay');
        element.classList.remove('active');
      }
    });
    
  });
});

/* Close Filter*/
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mobile-facets__header .close-trigger").forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      // Find the disclosure element that controls the mobile facets
      const disclosure = document.querySelector(".disclosure-has-popup");

      // Remove the "menu-opening" class so the drawer slides back down
      if (disclosure) {
        disclosure.classList.remove("menu-opening");
      }
    });
  });
});


/*Add styling on screen view */

document.addEventListener("DOMContentLoaded", function() {
  const section = document.getElementById("shopify-section-template--25055981535536__custom_liquid_V7F4Fb");

  if (!section) return; // exit if the element doesn't exist

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.classList.add('in-view-table');
      } else {
        section.classList.remove('in-view-table');
      }
    });
  }, { threshold: 0.3 }); // 30% visible

  observer.observe(section);
});

/*Shop Page move the Login after the paragraph*/
const headingLink = document.querySelector(".custom-two-column.section-template--24296564130096__custom_two_column_8G9wmX .heading-link");
const target = document.querySelector(".right-column .mb-4 p");

if (headingLink && target && target.parentNode) {
  target.parentNode.insertBefore(headingLink, target.nextSibling);
}

/* PDP move the Join Our Wine Club after the image on the right */
const headingLinkpdp = document.querySelector("#become-a-wayfinder-today\\! .heading-link");
const targetpdp = document.querySelector(".right-column .mb-4 img");

if (headingLinkpdp && targetpdp && targetpdp.parentNode) {
  targetpdp.parentNode.insertBefore(headingLinkpdp, targetpdp.nextSibling);
}

/* Our Winery Page move the Visit our cellar door after the image on the right */
const headingLinkwinery = document.querySelector("#wayfinder-wines .left-column .html-text a");
const targetwinery = document.querySelector("#wayfinder-wines .right-column .mb-4 img");

if (headingLinkwinery && targetwinery && targetwinery.parentNode) {
  targetwinery.parentNode.insertBefore(headingLinkwinery, targetwinery.nextSibling);
}

/* Our Ethos Page move the learn more about our ethos after the image on the right */
const headingLinkethos = document.querySelector("#learn-more-about-ethos .left-column .html-text a");
const targetethos = document.querySelector("#learn-more-about-ethos .right-column .mb-4 img");

if (headingLinkethos && targetethos && targetethos.parentNode) {
  targetethos.parentNode.insertBefore(headingLinkethos, targetethos.nextSibling);
}

/* Wine Hub Page*/
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname.includes('/apps/winehub')) {
    const header = document.querySelector("#shopify-section-sections--24296564654384__header");
    if (header) {
      header.classList.add("winehub-header");
    }
  }
});

/*Filters*/
document.addEventListener("DOMContentLoaded", function () {
  function openAllFilters() {
    document.querySelectorAll(".mobile-facets__details").forEach((details) => {
      details.setAttribute("open", "true");
    });

    document.querySelectorAll(".mobile-facets__submenu").forEach((submenu) => {
      submenu.style.display = "block";
      submenu.style.position = "static";
      submenu.style.opacity = "1";
      submenu.style.visibility = "visible";
      submenu.style.transform = "none";
    });

    // Hide redundant back buttons
    document.querySelectorAll(".mobile-facets__close-button").forEach((btn) => {
      btn.style.display = "none";
    });
  }

  // Initial load
  openAllFilters();

  // Re-run when any relevant trigger is clicked
  document.body.addEventListener("click", function (e) {
    const isClearAll =
      e.target.closest(".mobile-facets__clear") ||
      e.target.closest('[href*="filter"]');
    const isApplyFilter = e.target.closest(".button--primary");
    const isCloseTrigger = e.target.closest(".close-trigger");
    const isMobileFacets = e.target.closest(".mobile-facets");
    const isMobileFacetsOpen = e.target.closest(".mobile-facets__open");

    if (
      isClearAll ||
      isApplyFilter ||
      isCloseTrigger ||
      isMobileFacets ||
      isMobileFacetsOpen
    ) {
   // Wait a bit to let Shopify rebuild the DOM
      setTimeout(() => {
        openAllFilters();

        // ✅ Remove body lock on filter close/clear
        document.body.classList.remove("overflow-hidden-mobile");
      }, 400);
    }
  });
});

/* Announcement bar close option */
document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".announcement-bar-section");
  const closeBtn = document.querySelector(".announcement-bar__close");
  const header = document.querySelector(".shopify-section-header-sticky");
  const videoBanner = document.querySelector("section.video-banner");
  const overlay = document.querySelector(".overlay");
  const allDetails = document.querySelectorAll("details");
  const closeTriggers = document.querySelectorAll(".close-trigger");

  if (!bar || !closeBtn || !header) return;

  const EXPIRY_HOURS = 24;
  const savedData = JSON.parse(localStorage.getItem("announcementClosed")) || null;

  // --- Adjust submenu position ---
  const adjustSubmenuPosition = () => {
    const barVisible = getComputedStyle(bar).display !== "none";
    const barHeight = barVisible ? bar.offsetHeight : 0;
    const headerHeight = header.offsetHeight || 0;
    const scrollY = window.scrollY;
    const barOutOfView = scrollY > barHeight;
    const totalOffset = barOutOfView ? headerHeight : headerHeight + barHeight;

    document.querySelectorAll(".header__submenu").forEach((submenu) => {
      submenu.style.top = `${totalOffset}px`;
    });
  };

  // --- Adjust video banner margin ---
  const adjustVideoMargin = () => {
    if (!videoBanner) return;
    const barVisible = getComputedStyle(bar).display !== "none";
    const headerHeight = header.offsetHeight || 0;
    const barHeight = barVisible ? bar.offsetHeight : 0;
    videoBanner.style.marginTop = `-${barHeight + headerHeight}px`;
  };

  // --- Add/remove scrolled class ---
  const updateHeaderScrolledState = () => {
    const isScrolled = window.scrollY > 0;
    const anyMenuOpen = document.querySelector("details[open]");
    if (isScrolled || anyMenuOpen) {
      header.classList.add("scrolled-past-header");
    } else {
      header.classList.remove("scrolled-past-header");
    }
  };

  // --- Initial setup ---
  adjustVideoMargin();
  adjustSubmenuPosition();
  updateHeaderScrolledState();

  // --- Restore closed bar state ---
  if (savedData && Date.now() < savedData.expiry) {
    bar.style.display = "none";
    adjustVideoMargin();
    adjustSubmenuPosition();
    updateHeaderScrolledState();
    return;
  }

  // --- Handle bar closing ---
  const img = closeBtn.querySelector("img");
  if (img) img.style.pointerEvents = "none";

  closeBtn.addEventListener("click", () => {
    bar.classList.add("announcement-bar--hidden");
    setTimeout(() => {
      bar.style.display = "none";
      adjustVideoMargin();
      adjustSubmenuPosition();
      updateHeaderScrolledState();
    }, 300);

    const expiryTime = Date.now() + EXPIRY_HOURS * 60 * 60 * 1000;
    localStorage.setItem("announcementClosed", JSON.stringify({ expiry: expiryTime }));
  });

  // --- Scroll & Resize listeners ---
  window.addEventListener("scroll", () => {
    adjustSubmenuPosition();
    updateHeaderScrolledState();
  });
  window.addEventListener("resize", () => {
    adjustVideoMargin();
    adjustSubmenuPosition();
    updateHeaderScrolledState();
  });

  // --- Handle <details> open/close events ---
  document.addEventListener("toggle", (e) => {
    if (e.target.matches("details")) {
      requestAnimationFrame(() => {
        adjustSubmenuPosition();
        updateHeaderScrolledState();
      });
    }
  });

  // --- Add scrolled class when menu summary clicked ---
  document.querySelectorAll(
    ".shopify-section.shopify-section-group-header-group.section-header.shopify-section-header-sticky summary.header__menu-item.list-menu__item.link.focus-inset"
  ).forEach((menuSummary) => {
    menuSummary.addEventListener("click", () => {
      setTimeout(updateHeaderScrolledState, 50);
    });
  });

  // --- 🆕 Remove scrolled class when overlay is clicked ---
  if (overlay) {
    overlay.addEventListener("click", () => {
      if (window.scrollY === 0) {
        header.classList.remove("scrolled-past-header");
      }
    });
  }

  // --- 🆕 Remove scrolled class when close-trigger clicked ---
  if (closeTriggers.length > 0) {
    closeTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (window.scrollY === 0) {
          header.classList.remove("scrolled-past-header");
        }
      });
    });
  }

  // --- 🆕 Remove class when all details are closed ---
  allDetails.forEach((d) => {
    d.addEventListener("toggle", () => {
      if (!document.querySelector("details[open]") && window.scrollY === 0) {
        header.classList.remove("scrolled-past-header");
      }
    });
  });
});



/* Tab Dine With Us*/
document.addEventListener('DOMContentLoaded', () => {
  const anchor = document.querySelector('#shopify-section-template--25008238395696__rich_text_CQGFmF .rich-text__text.rte a');
  const tabBtn = document.querySelector('.tab-btn[data-tab="right-template--25008238395696__tabs_section_FXBb8C"]');

  if (!anchor || !tabBtn) return;

  anchor.addEventListener('click', (e) => {
    e.preventDefault();

    tabBtn.removeAttribute('disabled');

    // --- Smooth scroll with custom offset (e.g., for fixed header height) ---
    const headerOffset = 70; // change this to match your header height
    const elementPosition = tabBtn.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    // -----------------------------------------------------------------------

    // Click the tab after short delay to ensure visibility
    setTimeout(() => tabBtn.click(), 400);
  });
});


/* Rotate SVG on Filters */
document.addEventListener('DOMContentLoaded', () => {
  const filterFields = document.querySelectorAll('.facet-filters__field, .mobile-facets__sort');

  filterFields.forEach(field => {
    const select = field.querySelector('select');
    const icon = field.querySelector('svg');

    if (!select || !icon) return;

    select.addEventListener('click', () => {
      icon.classList.toggle('rotated');
    });
  });
});

/*Move wine info table and metafield list after description*/
document.addEventListener('DOMContentLoaded', function() {
  const productDescription = document.querySelector('.product__description');
  const productInfoTable = document.querySelector('.product-info-table.page-width');
  const additionalInfo = document.querySelector('.custom-metafield-list.additional-product-info.page-width');

  if (productDescription && productInfoTable) {
    productDescription.appendChild(productInfoTable);

    if (additionalInfo) {
      productInfoTable.insertAdjacentElement('afterend', additionalInfo);
    }
  }
});


/*Collection Page align the CTAs left side underneath align with product name*/
document.addEventListener("DOMContentLoaded", function() {
  function alignButtonsToProductName() {
    document.querySelectorAll(".card__content").forEach(card => {
      const productName = card.querySelector(".product-name");
      const quickAdd = card.querySelector(".product-add-to");
      const viewProduct = card.querySelector(".view-product-container");

      if (productName && (quickAdd || viewProduct)) {
        const cardRect = card.getBoundingClientRect();
        const nameRect = productName.getBoundingClientRect();
        const leftOffset = nameRect.left - cardRect.left;

        [quickAdd, viewProduct].forEach(el => {
          if (!el) return;
          el.style.marginLeft = leftOffset + "px";
          el.style.width = "auto";
          el.style.alignItems = "flex-start";
        });
      }
    });
  }

  // Run on load
  alignButtonsToProductName();

  // Re-run on resize
  window.addEventListener("resize", alignButtonsToProductName);

  // Re-run after Shopify AJAX filter reloads
  document.addEventListener("shopify:section:load", alignButtonsToProductName);

  // ✅ Re-run when filter links are clicked inside mobile filter
  const facetsWrapper = document.querySelector("#FacetsWrapperMobile");
  if (facetsWrapper) {
    facetsWrapper.addEventListener("click", (e) => {
      const target = e.target.closest("a, button, input[type='checkbox'], input[type='radio']");
      if (target) {
        setTimeout(alignButtonsToProductName, 2000);
      }
    });
  }

  // ✅ Re-run when a filter is removed (individual or "Remove all")
  const pillsForm = document.querySelector("#FacetFiltersPillsForm");
  if (pillsForm) {
    pillsForm.addEventListener("click", (e) => {
      const target = e.target.closest("a");
      if (target) {
        setTimeout(alignButtonsToProductName, 1000);
      }
    });
  }
});
